import { render, staticRenderFns } from "./AreaEmbargadaParana.vue?vue&type=template&id=e765ce0e&scoped=true&lang=pug"
import script from "./AreaEmbargadaParana.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaParana.vue?vue&type=script&lang=js"
import style0 from "./AreaEmbargadaParana.vue?vue&type=style&index=0&id=e765ce0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e765ce0e",
  null
  
)

export default component.exports